import { Table } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getConsignmentOrderMovementDetails } from '../../../../../appRedux/actions';

export const ConsignOrderMovements = ({ data = {}, type }) => {
  const dispatch = useDispatch();
  const { consignmentOrderMovement } = useSelector(
    (state) => state.consignmentOrder
  );

  useEffect(() => {
    if (data?.id) {
      dispatch(getConsignmentOrderMovementDetails(data.id, { type }));
    }
  }, [dispatch, data?.id, type]);

  const columns = [
    {
      title: 'Producto',
      dataIndex: 'productName',
      key: 'productName',
    },
    {
      title: 'Cantidad',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      title: 'Lote',
      dataIndex: 'allotment',
      key: 'allotment',
    },
    {
      title: 'Sucursal',
      dataIndex: 'branchName',
      key: 'branchName',
    },
    {
      title: 'Tipo',
      dataIndex: 'movementType',
      key: 'movementType',
    },
    {
      title: 'Movimiento',
      dataIndex: 'movementSource',
      key: 'movementSource',
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={consignmentOrderMovement}
      rowKey="movementId"
      pagination={false}
    />
  );
};
